






import Vue from 'vue'
import Component from 'vue-class-component'
import { Emit, Prop, Watch } from 'vue-property-decorator'
import ProjectServer from '../models/ProjectServer';
import store from '../store/store';
import Project from '../models/Project';
import { IsEmbedded } from '../constants/environment';

@Component
export default class AFKListener extends Vue
{
    currentSecondDiff = -1;
    
    get kickInterval() {
        if ((store.state as any).project.presentationMode)
        {
            return 3600;
        }
        return 1800;
    }

    kickWarnInterval = 60;
    lastNonAFKTime = new Date();
    
    get isWarningVisible()
    {
        let curTime = new Date();
        const seconds = (curTime.getTime() - this.lastNonAFKTime.getTime()) / 1000;
        this.currentSecondDiff = seconds;
        return this.secondsUntilKick <= this.kickWarnInterval;
    }

    get secondsUntilKick()
    {
        return Math.max(Math.round(this.kickInterval - this.currentSecondDiff), 0);
    }

    get secondsUntilKickString() {
        const s = this.secondsUntilKick;
        if (s == 1) return `${s} second`;
        return `${s} seconds`;
    }

    resetTimer()
    {
        this.lastNonAFKTime = new Date();
    }

    kick()
    {
        // To avoid spam in case of error
        this.resetTimer();

        let proj = (store.state as any).project.project as Project;
        this.$router.push('/')
        
        if (ProjectServer.instanceExists)
        {
            ProjectServer.instance.disconnect();
        }

        if (confirm('You have been disconnected due to inactivity.  Your work has been saved.  Would you like to reconnect to your project?'))
        {
            this.$router.push(`/app/connect/${proj.pid}`)
        }
        this.resetTimer();
    }

    checkLoop()
    {
        let curTime = new Date();
        const seconds = (curTime.getTime() - this.lastNonAFKTime.getTime()) / 1000;
        this.currentSecondDiff = seconds;

        if (this.secondsUntilKick <= 0)
        {
            this.kick();
            return;
        }
    }

    checkLoopInterval : NodeJS.Timeout | undefined = undefined;
    mounted()
    {
        if (IsEmbedded || this.$route.fullPath.includes('app/e/')) return;
        this.checkLoopInterval = setInterval(this.checkLoop, 500);

        // Listeners
        window.addEventListener('mousemove', this.resetTimer);
        window.addEventListener('wheel', this.resetTimer);
        window.addEventListener('mousedown', this.resetTimer);
        window.addEventListener('keydown', this.resetTimer);
    }

    beforeDestroy()
    {
        if (IsEmbedded || this.$route.fullPath.includes('app/e/')) return;
        
        // Kill animation frame
        if (this.checkLoopInterval)
        {
            clearInterval(this.checkLoopInterval);
        }

        window.removeEventListener('mousemove', this.resetTimer);
        window.removeEventListener('wheel', this.resetTimer);
        window.removeEventListener('mousedown', this.resetTimer);
        window.removeEventListener('keydown', this.resetTimer);
    }
}
